import React from 'react'
import PropTypes from 'prop-types'
import {
  VideoModalClose,
  VideoModalMain,
  VideoModalWrapper,
} from './index.style'
import useVimeo from '@hooks/useVimeo'
import { Caption } from '@components/TextStyles'
import YouTubePlayer from '@components/YouTubePlayer'
import TiktokPlayer from '@components/TiktokPlayer'
import { isMobile } from 'react-device-detect'

const VideoModalVimeoPlayer = ({ data }) => {
  const { videoId } = data
  const { $el } = useVimeo({
    id: videoId,
    autoplay: true,
    byline: false,
    controls: isMobile,
    loop: true,
    title: false,
  })

  return <VideoModalWrapper ref={$el} />
}

const VideoModal = ({ type, data, onClose }) => {
  return (
    <VideoModalMain>
      {type === 'ContentfulVimeoVideo' && <VideoModalVimeoPlayer data={data} />}

      {type === 'ContentfulYouTubeVideo' && <YouTubePlayer data={data} />}

      {type === 'ContentfulTiktokVideo' && <TiktokPlayer data={data} />}

      <VideoModalClose onClick={onClose}>
        <Caption>Close</Caption>
      </VideoModalClose>
    </VideoModalMain>
  )
}

VideoModal.propTypes = {
  type: PropTypes.oneOf(['ContentfulVimeoVideo', 'ContentfulYouTubeVideo', 'ContentfulTiktokVideo']),
  data: PropTypes.object,
  onClose: PropTypes.func,
}

export default VideoModal
